import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import logoPrimary from '../../assets/images/logo-primary.png';
import logoHorizontal from '../../assets/images/logo-horizontal.png';
import { redefinirSenha } from '../../api/auth';
import { extrairMensagemErro } from '../../components/common/ErroCarregamento';
import './Login.css';

export default function RedefinirSenha() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState('');
  const [concluido, setConcluido] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    if (novaSenha.length < 8) {
      setErro('A nova senha deve ter ao menos 8 caracteres.');
      return;
    }
    if (novaSenha !== confirmar) {
      setErro('As senhas não coincidem.');
      return;
    }
    setEnviando(true);
    try {
      await redefinirSenha(token, novaSenha);
      setConcluido(true);
    } catch (err) {
      setErro(extrairMensagemErro(err, 'Não foi possível redefinir a senha. O link pode ter expirado.'));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="login-page">
      {/* ===== Painel esquerdo — marca ===== */}
      <div className="login-brand">
        <div className="login-brand__bars" aria-hidden="true">
          <i className="login-brand__bar login-brand__bar--1" />
          <i className="login-brand__bar login-brand__bar--2" />
          <i className="login-brand__bar login-brand__bar--3" />
        </div>

        <div className="login-brand__hero">
          <img src={logoPrimary} alt="AM Gestão" className="login-brand__logo" />
          <div className="login-brand__rule" />
          <p className="login-brand__text">
            Plataforma de gestão da jornada de acreditação hospitalar com base nos padrões da
            ONA.
          </p>
        </div>

        <div className="login-brand__footer">
          Desenvolvido por <strong>Datafit</strong>
        </div>
      </div>

      {/* ===== Painel direito — formulário ===== */}
      <div className="login-form-panel">
        <div className="login-form-inner">
          <div className="login-form__logo">
            <img src={logoHorizontal} alt="AM Gestão" />
          </div>

          <h1 className="login-form__title">Criar nova senha</h1>

          {!token ? (
            <>
              <p className="login-form__subtitle">
                Este link é inválido ou incompleto. Solicite um novo link de redefinição.
              </p>
              <Link to="/esqueci-senha" className="login-form__forgot" style={{ display: 'inline-block', marginTop: 20 }}>
                Solicitar novo link
              </Link>
            </>
          ) : concluido ? (
            <>
              <p className="login-form__subtitle">Senha redefinida com sucesso.</p>
              <Link
                to="/login"
                className="am-btn-primary"
                style={{ marginTop: 8, textDecoration: 'none' }}
              >
                <span className="ms">login</span>
                IR PARA O LOGIN
              </Link>
            </>
          ) : (
            <>
              <p className="login-form__subtitle">Escolha uma nova senha para acessar o portal.</p>

              <form className="login-form__fields" onSubmit={handleSubmit}>
                <label className="am-field">
                  <div className="am-field__label-row">
                    <span className="am-field__label">Nova senha</span>
                    <button type="button" className="am-field__toggle" onClick={() => setShowPw((v) => !v)}>
                      <span className="ms">{showPw ? 'visibility_off' : 'visibility'}</span>
                      {showPw ? 'Ocultar' : 'Mostrar'}
                    </button>
                  </div>
                  <input
                    type={showPw ? 'text' : 'password'}
                    value={novaSenha}
                    onChange={(e) => setNovaSenha(e.target.value)}
                    placeholder="Mínimo 8 caracteres"
                    autoComplete="new-password"
                    required
                  />
                </label>

                <label className="am-field">
                  <div className="am-field__label-row">
                    <span className="am-field__label">Confirmar nova senha</span>
                  </div>
                  <input
                    type={showPw ? 'text' : 'password'}
                    value={confirmar}
                    onChange={(e) => setConfirmar(e.target.value)}
                    placeholder="Repita a nova senha"
                    autoComplete="new-password"
                    required
                  />
                </label>

                {erro && <div className="login-form__error">{erro}</div>}

                <button type="submit" className="am-btn-primary" disabled={enviando}>
                  <span className="ms">lock_reset</span>
                  {enviando ? 'SALVANDO...' : 'REDEFINIR SENHA'}
                </button>
              </form>
            </>
          )}

          <div className="login-form__footer">ACF Moura · Consultoria ONA © 2026</div>
        </div>
      </div>
    </div>
  );
}
